import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button", "iconDown", "iconUp"];

  toggle() {
    const isTruncated = this.contentTarget.dataset.truncated === "true";

    if (isTruncated) {
      // Expand
      this.contentTarget.style.maxHeight = "none";
      this.contentTarget.style.overflow = "visible";
      this.contentTarget.dataset.truncated = "false";
      this.iconDownTarget.classList.add("hidden");
      this.iconUpTarget.classList.remove("hidden");
      this.buttonTarget.setAttribute("aria-label", "Voir moins");
    } else {
      // Collapse
      this.contentTarget.style.maxHeight = "60px";
      this.contentTarget.style.overflow = "hidden";
      this.contentTarget.dataset.truncated = "true";
      this.iconUpTarget.classList.add("hidden");
      this.iconDownTarget.classList.remove("hidden");
      this.buttonTarget.setAttribute("aria-label", "Voir plus");
    }
  }
}